/* EkDoTee slide-out cart: opens from the right after adding to bag, or from the bag icon. */
(function () {
  if (!window.fetch || document.body.classList.contains('template-cart')) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TEES = ['T-shirts', 'Baby Tee'], BADGE = 'Badges';
  var nativeFetch = window.fetch;
  var badgeCache = null, busy = false, lastFocus = null;
  document.documentElement.classList.add('ekd-drawer');

  function money(c) { return '₹' + Math.round(c / 100).toLocaleString('en-IN'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var FREE_ICON = '<svg viewBox="0 0 48 48" width="40" height="40" aria-hidden="true"><circle cx="24" cy="24" r="20" fill="#D4FF3A" stroke="#141414" stroke-width="2.5"/><circle cx="24" cy="24" r="14.5" fill="none" stroke="#141414" stroke-width="1.5" stroke-dasharray="3 3.5"/><text x="24" y="29" text-anchor="middle" font-family="Arial Black, Arial, sans-serif" font-weight="900" font-size="11" fill="#141414">FREE</text></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  var el = document.createElement('div');
  el.className = 'cd'; el.hidden = true;
  el.innerHTML = '<div class="cd__overlay" data-cd-close></div>' +
    '<aside class="cd__panel" role="dialog" aria-modal="true" aria-labelledby="CdTitle" tabindex="-1">' +
      '<div class="cd__head"><h2 id="CdTitle" class="cd__title">Your bag <span data-cd-count></span></h2><button type="button" class="cd__close" data-cd-close aria-label="Close bag">' + CLOSE + '</button></div>' +
      '<div class="cd__body" data-cd-body></div>' +
      '<div class="cd__foot" data-cd-foot></div>' +
    '</aside>';
  document.body.appendChild(el);
  var body = el.querySelector('[data-cd-body]'), foot = el.querySelector('[data-cd-foot]'), panel = el.querySelector('.cd__panel');

  function counts(cart) {
    var t = 0, b = 0;
    cart.items.forEach(function (i) { if (TEES.indexOf(i.product_type) > -1) t += i.quantity; else if (i.product_type === BADGE) b += i.quantity; });
    return { tees: t, badges: b };
  }
  function getBadges() {
    if (badgeCache) return Promise.resolve(badgeCache);
    return nativeFetch.call(window, root + 'collections/feminitee-badges/products.json?limit=8')
      .then(function (r) { return r.json(); })
      .then(function (d) { badgeCache = (d.products || []).filter(function (p) { return p.variants && p.variants.some(function (v) { return v.available; }); }).slice(0, 4); return badgeCache; })
      .catch(function () { return []; });
  }
  function offerHtml(cart, badges) {
    var c = counts(cart);
    if (c.tees === 1) return '<div class="cd-offer">' + FREE_ICON + '<div><p class="cd-offer__t">Ek tee done. Do tee, badge free.</p><p class="cd-offer__s">Add one more tee and pick any badge on us.</p><a class="cd-offer__link" href="' + root + 'collections/all-tees">Shop tees</a></div></div>';
    if (c.tees >= 2 && c.badges === 0) {
      var picks = (badges || []).map(function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0];
        var src = p.images && p.images[0] ? img(p.images[0].src, 200) : '';
        return '<li class="cd-pick"><span class="cd-pick__img">' + (src ? '<img src="' + esc(src) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</span><button type="button" class="cd-pick__add" data-cd-add="' + v.id + '">Add free</button></li>';
      }).join('');
      return '<div class="cd-offer cd-offer--unlock">' + FREE_ICON + '<div><p class="cd-offer__t">Ek tee, do tee, badge free</p><p class="cd-offer__s">You unlocked it. Tap a badge to add it free.</p>' + (picks ? '<ul class="cd-picks" role="list">' + picks + '</ul>' : '') + '<a class="cd-offer__link" href="' + root + 'collections/feminitee-badges">See all badges</a></div></div>';
    }
    if (c.tees >= 2 && c.badges > 0) return '<div class="cd-offer cd-offer--done">' + FREE_ICON + '<div><p class="cd-offer__t">Ek, do, badge free. Done.</p><p class="cd-offer__s">One badge is on us with your 2 tees.</p></div></div>';
    return '';
  }
  function render(cart) {
    el.querySelector('[data-cd-count]').textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; });
    if (!cart.item_count) {
      body.innerHTML = '<div class="cd-empty"><p class="cd-empty__t">Your bag is empty.</p><p>Your tees are waiting. They have opinions.</p><a class="btn" href="' + root + 'collections/all-tees">Shop tees</a></div>';
      foot.innerHTML = ''; return Promise.resolve();
    }
    var c = counts(cart);
    var need = c.tees >= 2 && c.badges === 0;
    return (need ? getBadges() : Promise.resolve([])).then(function (badges) {
      var items = cart.items.map(function (i, idx) {
        var line = idx + 1;
        var opts = (i.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' / ');
        var disc = (i.discounts || []).map(function (d) { return '<span class="cd-item__disc">' + esc(d.title) + '</span>'; }).join('');
        var was = i.original_line_price > i.final_line_price ? '<s>' + money(i.original_line_price) + '</s>' : '';
        return '<li class="cd-item">' +
          '<a class="cd-item__img" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(img(i.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="cd-item__info"><a class="cd-item__title" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' +
            (opts ? '<p class="cd-item__opts">' + opts + '</p>' : '') + disc +
            '<div class="cd-item__row"><div class="cd-qty"><button type="button" data-cd-qty="' + line + '" data-q="' + (i.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button><span>' + i.quantity + '</span><button type="button" data-cd-qty="' + line + '" data-q="' + (i.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
            '<button type="button" class="cd-item__remove" data-cd-qty="' + line + '" data-q="0">Remove</button></div></div>' +
          '<div class="cd-item__price">' + was + '<span>' + (i.final_line_price === 0 ? 'Free' : money(i.final_line_price)) + '</span></div>' +
        '</li>';
      }).join('');
      body.innerHTML = offerHtml(cart, badges) + '<ul class="cd-items" role="list">' + items + '</ul>';
      var saved = cart.total_discount > 0 ? '<div class="cd-foot__row cd-foot__save"><span>You saved</span><span>' + money(cart.total_discount) + '</span></div>' : '';
      foot.innerHTML = saved + '<div class="cd-foot__row cd-foot__total"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
        '<p class="cd-foot__note">Taxes included. Shipping calculated at checkout.</p>' +
        '<a class="btn btn--accent btn--full cd-foot__checkout" href="' + root + 'checkout">Checkout</a>' +
        '<a class="cd-foot__view" href="' + root + 'cart">View bag</a>';
    });
  }
  function getCart() { return nativeFetch.call(window, root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function open(cart) {
    var p = cart ? Promise.resolve(cart) : getCart();
    return p.then(render).then(function () {
      if (!el.hidden && el.classList.contains('is-open')) return;
      lastFocus = document.activeElement;
      el.hidden = false; void el.offsetWidth; el.classList.add('is-open');
      document.documentElement.classList.add('cd-lock');
      panel.focus({ preventScroll: true });
      var toast = document.getElementById('CartToast'); if (toast && !toast.classList.contains('is-error')) toast.hidden = true;
    });
  }
  function close() {
    el.classList.remove('is-open');
    document.documentElement.classList.remove('cd-lock');
    setTimeout(function () { el.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function change(line, q) {
    if (busy) return; busy = true; el.classList.add('is-busy');
    nativeFetch.call(window, root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: q }) })
      .then(function (r) { return r.json(); }).then(render)
      .finally(function () { busy = false; el.classList.remove('is-busy'); });
  }
  function addBadge(id, btn) {
    if (busy) return; busy = true; el.classList.add('is-busy'); if (btn) btn.textContent = 'Adding';
    nativeFetch.call(window, root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: 1 }) })
      .then(getCart).then(render)
      .finally(function () { busy = false; el.classList.remove('is-busy'); });
  }
  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-close]')) { close(); return; }
    var q = e.target.closest('[data-cd-qty]'); if (q) { change(Number(q.getAttribute('data-cd-qty')), Math.max(0, Number(q.getAttribute('data-q')))); return; }
    var a = e.target.closest('[data-cd-add]'); if (a) { addBadge(a.getAttribute('data-cd-add'), a); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) close(); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]'); if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var href = a.getAttribute('href').split('?')[0].replace(/\/$/, '');
    if ((href === root + 'cart' || href === '/cart') && a.closest('header, .header, [class*="header"]')) { e.preventDefault(); open(); }
  });
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(this, arguments);
    if (/\/cart\/add/.test(url)) p.then(function (r) { if (r.ok) setTimeout(function () { open(); }, 150); }).catch(function () {});
    return p;
  };
  window.EkdDrawer = { open: open, close: close };
})();
